import { closeCurrentWebView } from "@/utils/native/interaction";

export default [
  {
    path: "/wt-product-list",
    name: "MallProductList",
    meta: {
      title: "商品列表"
    },
    component: () =>
      import(
        /* webpackChunkName: "mall-plp" */ "@/views/mall/MallProductList.vue"
      )
  },
  {
    path: "/wt-product-list-by-name",
    name: "MallProductListByName",
    meta: {
      title: "商品列表"
    },
    component: () =>
      import(
        /* webpackChunkName: "mall" */ "@/views/mall/MallProductListByName.vue"
      )
  },
  {
    path: "/wt-shopping-cart",
    name: "MallShoppingCart",
    meta: {
      title: "购物车",
      showCartDelete: true,
      keepAlive: true
    },
    component: () =>
      import(/* webpackChunkName: "mall" */ "@/views/mall/MallShoppingCart.vue")
  },
  {
    path: "/wt-place-order-confirm",
    name: "MallPlaceOrderConfirm",
    meta: {
      title: "订单确认",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "mall" */ "@/views/mall/MallPlaceOrderConfirm.vue"
      )
  },
  {
    path: "/wt-mall-coupon",
    name: "MallCoupon",
    meta: { title: "选择优惠券" },
    component: () =>
      import(/* webpackChunkName: "mall" */ "@/views/mall/MallCoupon.vue")
  },
  {
    path: "/wt-place-order-success",
    name: "MallPlaceOrderSuccess",
    meta: { title: "提交成功", showHeader: false },
    component: () =>
      import(
        /* webpackChunkName: "mall" */ "@/views/mall/MallPlaceOrderSuccess.vue"
      )
  },
  {
    path: "/wt-order-payment-success",
    name: "MallOrderPaymentSuccess",
    meta: { title: "支付成功" },
    component: () =>
      import(
        /* webpackChunkName: "mall" */ "@/views/mall/MallOrderPaymentSuccess.vue"
      )
  },
  {
    path: "/wt-order-list",
    name: "MallOrderList",
    meta: {
      title: "我的订单"
    },
    component: () =>
      import(
        /* webpackChunkName: "mall-order" */ "@/views/mall/MallOrderList.vue"
      )
  },
  {
    path: "/wt-order-detail/:code",
    name: "MallOrderDetail",
    meta: {
      title: "订单详情",
      showHeader: true,
      background: "#F5F5F5",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "mall-order" */ "@/views/mall/MallOrderDetail.vue"
      )
  },
  {
    path: "/wt-my-coupon",
    name: "MallMyCoupon",
    meta: {
      title: "下单券",
      showHeader: true,
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "my-coupon" */ "@/views/mall/MallMyCoupon.vue"
      )
  },
  {
    path: "/wt-payment/:code?",
    name: "MallPayment",
    meta: {
      title: "支付订单"
    },
    component: () =>
      import(
        /* webpackChunkName: "mall-payment" */ "@/views/mall/MallPayment.vue"
      )
  },
  {
    path: "/wt-my-bond",
    name: "MallMyBond",
    meta: {
      title: "实物券",
      showHeader: false,
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(/* webpackChunkName: "my-bond" */ "@/views/mall/MallMyBond.vue")
  }
];
